import React, { useEffect, useState } from 'react';
import styles from './invalidPage.scss';
import HelmetComponent from '../../utils/HelmetHelper';
import SimilarAdsSection from '../../containers/AdDetailsPage/AdDetailsPageWeb/SimilarAdsSection';
import { default as SimilarAdsSectionMobile } from '../../containers/AdDetailsPage/AdDetailsPageMobile/SimilarAdsSection';
import { useSelector } from 'react-redux';
import { selectFavoriteIds } from '../../routes/Favorite/favorite.ducks';
import { buildBaseUrl, checkEmptyObject, getWindowWidth, isMobileScreen } from '../../services';
import { Loading } from '../Loading';
import { Button } from 'antd';
import history from '../../history';

const InvalidPage = () => {
  const [adData, setAdData] = useState({});
  const [loadingSimilar, setLoadingSimilar] = useState(true);

  const favoriteIds = useSelector(selectFavoriteIds);
  const isMobile = isMobileScreen(getWindowWidth());

  useEffect(() => {
    // @ts-ignore
    window.notFound = true;

    return () => {
      // @ts-ignore
      window.notFound = false;
    };
  }, []);

  useEffect(() => {
    // @ts-ignore
    setAdData(history.location.state ? history.location.state.adNotFoundData : {});

    return () => {
      setAdData({});
    }
  }, []);

  return (
    <React.Fragment>
      <HelmetComponent
        title={`${"404"} | ${"INDEX OGLASI"}`}
      />
      <div className={`child-center ${styles.text}`}>
        {checkEmptyObject(adData) ? "Nažalost, ovaj oglas više nije dostupan." : "Ups, ova stranica nije dostupna"}
      </div>

      {checkEmptyObject(adData) && (
        <div className={`child-center`}>
          {loadingSimilar && <Loading />}

          {!isMobile ? (
            <SimilarAdsSection
              hasFavorite={false}
              adId={adData.adId}
              favoriteIds={favoriteIds}
              category={adData.category}
              module={adData.module}
              setLoadingSimilar={setLoadingSimilar}
            />
          ) : (
            <SimilarAdsSectionMobile
              hasFavorite={false}
              adId={adData.adId}
              favoriteIds={favoriteIds}
              category={adData.category}
              module={adData.module}
              setLoadingSimilar={setLoadingSimilar}
              noBackground={true}
            />
          )}
          {adData.redirectUrl && (
            <Button
              className={styles.button}
              onClick={() => {
                const win = window.open(buildBaseUrl("/" + adData.redirectUrl), "_blank");
                win.focus();
              }}
              type='primary'
            >
              {"Pretraži oglase"}
            </Button>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default InvalidPage;



// WEBPACK FOOTER //
// ./src/components/InvalidPage/InvalidPage.tsx